module.exports = __webpack_public_path__ + "static/media/szczalka.93300fbd.svg";